module.exports = {
    success: require('./registration-success'),
    submitted: require('./registration-submitted'),
    start: require('./registration-start'),
    abandoned: require('./registration-abandoned')
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/atmmapper/registration.js
 **/